module.exports = __webpack_public_path__ + "img/148.59c9f98d.jpg";